import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import {
	updateCourseDetails,
	fetchInstruction,
	setShowGrade,
	setPreviewMode,
} from '../../redux/myCourse/myCourse.actions';
import { setGetUserInfo } from '../../redux/profile/profile.actions';
import { changeActiveCourse } from '../../redux/changeCourse/changeCourse.actions';
import Status from './status';
import Detail from './courseDetail/details.container';
import Notification from '../notifications';
import TestInstruction from '../common/testInstruction';
import PermitMicModal from '../common/permitMic';
import ReviewAttemptModal from '../common/reviewAttemptModal';
import { Link } from 'react-router-dom';
import GetGrade from '../common/getGrade';
import { appendScript } from '../../utils/appendScript';
import EchoTest from '../common/EchoTest';
import { getParameterByName } from '../../utils/commonFunctions';
import DefaultLayoutHOC from '../layoutHOC/defaultLayout';
import ListAnimation from '../utils/animations/list';
import Card from 'react-bootstrap/Card';

const MyCourse = ({
	setShowGrade,
	updateCourseDetails,
	changeActiveCourse,
	title,
	getGrade,
	newUser,
	isOlympiad,
	category,
	setGetUserInfo,
	setPreviewMode,
	previewMode,
	product_id,
	coachDetails: { completed_calls, role_name },
	coachDetails,
	course_id,
	isEmailUpdate,
}) => {
	useEffect(() => {
		if (getParameterByName('previewMode') === '1') {
			setPreviewMode(true);
		}
	}, [setPreviewMode]);

	useEffect(() => {
		const setActiveCourse = async () => {
			await changeActiveCourse(getParameterByName('course_id'));
		};
		document.getElementById('chat-circle').style.display = 'block';

		if (!!getParameterByName('course_id')) {
			setActiveCourse();
		} else {
			updateCourseDetails();
		}
	}, [updateCourseDetails, changeActiveCourse]);

	useEffect(() => {
		if (getGrade) {
			setShowGrade(true);
		}
	}, [getGrade, setShowGrade]);

	const userDetailsObj = JSON.parse(localStorage.getItem('userDetails'));
	useEffect(() => {
		let isProfileUpdated =
			userDetailsObj !== null
				? userDetailsObj.user_phone !== null &&
				  userDetailsObj.user_phone !== 'null' &&
				  userDetailsObj.user_phone !== ''
				: false;
		let ignoreUpdateTime =
			localStorage.getItem('ignoreUpdateTime') !== null
				? moment(localStorage.getItem('ignoreUpdateTime'))
				: moment().subtract(1, 'day');
		let now = moment();
		if (
			isOlympiad &&
			!isProfileUpdated &&
			now.diff(ignoreUpdateTime, 'days') > 0
		) {
			setGetUserInfo(true);
		} else if (newUser && !isOlympiad) {
			appendScript('user_info');
		}
	}, [isOlympiad, newUser, setGetUserInfo, userDetailsObj]);
		let coachMsg = ""
		let coachTitle = "STEP COACH Calls and Tasks"
		let coachT1 = ""

		if (completed_calls == 0 && role_name == "" && course_id == "487") {
			coachTitle = "Welcome to Coach Unlimited!"
			coachT1 = "Hello, You are now a part of a <span>HIGHLY PERSONALISED</span> English course that will be <span>UNIQUELY DESIGNED</span> for your needs."
			coachMsg = "Please answer the following three questions to help us build out the right course for your needs. Happy Learning!"
		}
		if(isEmailUpdate){
			window.location = "/profile?boa=1";
		}
	return (
		<>
			<ListAnimation className=" courseContainer">
				<Notification />
				<div className="coursepage_course_name">{title}</div>
				{previewMode ? (
					<Link to={`/purchase?productID=${product_id}`} className="changecourse">
						<i className="fa fa-undo"></i>
						<span>Back to product page</span>
					</Link>
				) : null}
				{!coachMsg && <Status/>}
				{!!coachMsg ? (
				<Card>
					<Card.Header>
						<h4 class="tiktik" dangerouslySetInnerHTML={{ __html: coachT1 }}></h4>
					</Card.Header>
				</Card>
				): null }
				<Detail />
			</ListAnimation>

			<TestInstruction />
			<EchoTest />
			<ReviewAttemptModal />
			<GetGrade />
			<PermitMicModal />
		</>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		updateCourseDetails: () => dispatch(updateCourseDetails()),
		changeActiveCourse: (id) => dispatch(changeActiveCourse(id)),
		fetchInstruction: (elementId, courseId, isReview = false) =>
			dispatch(fetchInstruction({ elementId, courseId, isReview })),
		setShowGrade: (val) => dispatch(setShowGrade(val)),
		setGetUserInfo: (val) => dispatch(setGetUserInfo(val)),
		setPreviewMode: (val) => dispatch(setPreviewMode(val)),
	};
};

const mapStateToProps = (state) => {
	const {
		elementId,
		title,
		getGrade,
		courseType,
		category,
		previewMode,
		coachDetails: { total_calls, completed_calls, show_feedback, feedback_url, role_name },
		coachDetails,
		course_id,
		isEmailUpdate,
	} = state.rootReducer.myCourse;

	const {
		isOlympiad,
		newUser,
		isRetail,
		returnPath,
	} = state.rootReducer.loginDetails;
	const { productData: { product_id } = {} } = state.rootReducer.buyCourse;
	return {
		elementId,
		title,
		getGrade,
		isOlympiad,
		newUser,
		isRetail,
		courseType,
		returnPath,
		category,
		previewMode,
		product_id,
		coachDetails: { completed_calls, role_name },
		coachDetails,
		course_id,
		isEmailUpdate,
	};
};

export default withRouter(
	compose(
		connect(mapStateToProps, mapDispatchToProps),
		DefaultLayoutHOC,
	)(MyCourse),
);
